<button
  nz-button
  nzType="default"
  nzSize="large"
  [nzBlock]="fullSize"
  [nzLoading]="loading$ | async"
  (click)="toggleHideTranslations()"
>
  {{ (isTranslationsHidden ? 'SHOW_TRANSLATIONS' : 'HIDE_TRANSLATIONS') | translate }}
</button>
